import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import VuetifyConfirm from 'vuetify-confirm'

Vue.use(Vuetify, {});
Vue.use(VuetifyConfirm);
